import { Button, Form, Input, Modal, message } from "antd";
import { useEffect, useState } from "react";
import { serverFetch } from "../../server";

const SettingsProgLicense = ({ progId, licenseId, visible, onClose }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [item, setItem] = useState(null);

  const getData = () => {
    if (!licenseId) return;
    setLoading(true);
    serverFetch(`dict/license/${progId}/${licenseId}`)
      .then((data) => {
        setItem(data);
        form.setFieldsValue(data);
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

  useEffect(() => {
    if (visible && licenseId) getData();
  }, [visible, licenseId]);

  const onValuesChange = (changedValues) => {
    setItem(prev => ({ ...prev, ...changedValues }));
  };

  const handleSave = async () => {
    if (!item) return;
    try {
      setLoading(true);
      const method = licenseId ? "PUT" : "POST";
      await serverFetch(`dict/license`, {
        method,
        bodyData: licenseId ? item : { ...item, idProg: progId }
      });
      message.success(licenseId ? "Лицензия обновлена" : "Лицензия добавлена");
      form.resetFields();
      onClose(true);
    } catch (e) {
      setLoading(false);
      if (e.userMessage) message.error(e.userMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose(false);
  };

  return (
    <Modal
      title={licenseId ? "Редактировать лицензию" : "Добавить лицензию"}
      open={visible}
      onCancel={handleCancel}
      footer={null}
      width={500}
      destroyOnClose
    >
      <div style={{ maxWidth: "90%" }}>
        <Form
          form={form}
          onValuesChange={onValuesChange}
          layout="vertical"
          disabled={loading}
        >
          <Form.Item
            label="Название"
            name="name"
            rules={[{ required: true, message: 'Введите название лицензии!' }]}
          >
            <Input placeholder="Введите название лицензии" />
          </Form.Item>

          <Form.Item label="Комментарий" name="komment">
            <Input.TextArea rows={3} placeholder="Введите комментарий" />
          </Form.Item>
        </Form>

        <div style={{ marginTop: 16, textAlign: 'right' }}>
          <Button onClick={handleCancel} style={{ marginRight: 8 }}>Отмена</Button>
          <Button type="primary" onClick={handleSave} loading={loading}>Сохранить</Button>
        </div>
      </div>
    </Modal>
  );
};

export default SettingsProgLicense;